<template>
	<div id="page404">
		<div class="center">
			<h3 style="">QLINK酷联客官网</h3>
			<small>全新改版升级中···</small>
			<p>敬请期待！</p>
			<el-button @click="fnToRouter('/')">返回主页</el-button>
			<el-button @click="$router.go(-1)">返回上一页</el-button>
			<div>资讯热线0592-8222272 / 5638000</div>
		</div>
	</div>
</template>
<script>
	export default {
		//数据
		data() {
			return {
			}
		},
		//计算数据
		computed: {			
		},
		//参数数据
		props: {			
		},
		//方法
		methods: {
		},
		//组件
		components: {
		},
		//生命周期-创建
		created() {
		},
		//生命周期-准备就绪
		mounted(){
		},
		//监控变量
		watch: {
		}
	}
</script>
<style lang="less">
	@import url("../assets/common.less");
	#page404{
		width: 100%;
		height: 100vh;
		background-color: #212930;
		background-image:url("../assets/img/404/background.png");
		background-repeat: no-repeat;
		background-position: center 20px;
		background-size: 80vh;
		.center {
			width:50%;
			margin:0 auto;
			padding-top :65vh;
			text-align: center;
			h3{
				color: @theme-color;
			}
			small{
				color: #FFF;
				font-size: 0.8em;
			}
			p{
				color:#FFF;
				font-size: 0.9em;
			}
			div{
				font-size: 0.6em;
			}
			.el-button{
				margin: 20px;
				width: calc(~"174px * 0.8");
				height: calc(~"44px * 0.8");
				background-size: 100% 100%;
				background-color: inherit;
				background-image: url("../assets/img/404/btn.png");
				background-size: 100% 100%;
				color: #171C21;
				
				border:0; 
				&:hover{
					color: #FFF;
					background-image: url("../assets/img/404/btn_hover.png");
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// 404.vue?60db29ca